
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ControlPanelFeedbackModal',

  data() {
    return {
      feedback: '',
      okToContact: false,
      isLoading: false
    }
  },

  methods: {
    submitFeedback(close: () => void) {
      this.isLoading = true
      //! Add logic
      const feedbackDidSubmit = true
      if (feedbackDidSubmit) {
        close()
      }
      this.isLoading = false
    }
  }
})
